require("./../plugins/jquery.lettering");
// require('is-in-viewport');
require( 'waypoints/lib/noframework.waypoints.js' );
require( 'waypoints/lib/shortcuts/inview.js' );

$(function () {
    var timer = setInterval( function(){
        if($('body').hasClass('loaded')) {
            clearInterval(timer);
            // console.log('line animation loaded');
            setTimeout(function(){
                init();
            },800)
        }
    }, 500);

    function init(){
        const selectorString = '.line-animation';
        $(selectorString).each(function () {
            const $this = $(this);
            divideLines($this);

            const waypoint = new Waypoint({
                element: $this[0],
                handler: function(direction) {
                    $this.addClass('in');
                    // console.log('in');
                },
                offset: '75%',
            })

            // const inview = new Waypoint.Inview({
            //     element: $this[0],
            //     exited: function(direction) {
            //         $this.removeClass('in');
            //     },
            // })
        });
    }

    function divideLines(target) {
        target.text(target.text().replace(/(\r\n|\n|\r)/gm, " "))
        target.lettering("words");
        let line = 1;
        let base = target.find('span').eq(0).offset().top;

        for (var i = 0; i < target.find('span').length; i++) {
            if (target.find('span').eq(i).offset().top > base) {
                base = target.find('span').eq(i).offset().top;
                line++;
            }
            target.find('span').eq(i).data('line', line);
            target.find('span').eq(i).css({
                'transition-delay': ((line - 1) * 0.05) + 's'
            });
        }
        if (target.parent().find('.more-btn').length > 0) target.parent().find('.more-btn').css({
            'transition-delay': ((line) * 0.05) + 's'
        });
    }
});

